import BaseServiceHttp from '../baseService'
class CategoriasObras extends BaseServiceHttp {
  constructor(id) {
    const resource = 'categorias-obras'
    const relationship = {}
    const baseURL = process.env.REACT_APP_API_URL
    super(id, resource, relationship, baseURL)
  }
}

export default id => new CategoriasObras(id)
